import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import DataTable from '../DataTable';
import Spinner from '../Spinner';
import StationPermissionList from '../Permission/StationPermissionList'
import {observable, toJS} from "mobx";
import jwtDecode from 'jwt-decode';
import Modal from "../Modal";
import ParameterPermissionList from "../Permission/ParameterPermissionList";
import TabBar from "../TabBar";

@inject('userStore', 'rolePermissionStore')
@observer
class UserList extends Component {
  // static propTypes = {
  // params: PropTypes.shape().isRequired,
  // route: PropTypes.shape().isRequired,
  // children: PropTypes.node,
  // }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  }

  slug = 'user';
  columns = [
    {key: 'id', label: 'ID'},
    {key: 'username', label: 'Username', searchable: true},
    {key: 'name', label: 'Name', searchable: true},
    {key: 'designation', label: 'Designation', searchable: true},
    // { key: 'role_id', label: 'Role' , searchable: true},
    {key: 'role_name', label: 'Role', searchable: true},
    {key: 'email', label: 'Email', searchable: true},
    {key: 'mobile', label: 'Mobile No.'}
  ];

  constructor(props) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
  }

  @observable allPermissions = [];
  @observable selectedUser = null;

  componentWillMount() {
    const {userStore, rolePermissionStore} = this.props;
    userStore.fetchItems();
    rolePermissionStore.fetchAllRoles();
  }

  handleDelete(idOrIds) {
    console.log('handleDelete', idOrIds);
    this.props.userStore.removeItems(idOrIds);
  }

  onSelectUser = e => {
    const { router } = this.context;
    router.replace(`/user/${e.id}/permission`);
    this.selectedUser = {
      id: e.id,
      name: e.name
    };
  };

  render() {
    const {userStore, children, rolePermissionStore, params: {id}} = this.props;

    if (userStore.isLoading && !children) {
      return <Spinner />;
    }


    return (
      <div>
        <DataTable
          data={toJS(userStore.items)}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          onSelect={rolePermissionStore.validateRole('view permission') ? this.onSelectUser : null}
          resource='user'
          paginate
        />
        {children}
      </div>
    );
  }
}

export default UserList;



// WEBPACK FOOTER //
// ./src/components/User/UserList.js